import { render, staticRenderFns } from "./item.children.vue?vue&type=template&id=50610c09&"
import script from "./item.children.vue?vue&type=script&lang=js&"
export * from "./item.children.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports